import { APIData } from "types/cms/frontendTypes"
import { isEqual, omit } from 'lodash'

export const SurveyTemplateUtils = {

  /**
   * Get the diff between new and old survey template
   * Only returns fields that have changed
   */
  getTemplateDiff: (
    newTemplate: Partial<APIData<'api::survey-template.survey-template'>>,
    oldTemplate: APIData<'api::survey-template.survey-template'>
  ): Partial<APIData<'api::survey-template.survey-template'>> => {
    
    const diff: Partial<APIData<'api::survey-template.survey-template'>> = {}
    
    // Compare label
    if (newTemplate.label && !isEqual(newTemplate.label, oldTemplate.label)) {
      diff.label = newTemplate.label
    }
    
    // Normalize templateQuestions for comparison - remove IDs and ensure consistent structure
    const normalizeTemplateQuestions = (templateQuestions: any[] | undefined) => {
      const questionsArray = templateQuestions || []
      return questionsArray.map((tq) => {
        const normalized = omit(tq, 'id')
        // Normalize branchingRules - remove IDs from each branching rule
        if (normalized.branchingRules && Array.isArray(normalized.branchingRules)) {
          normalized.branchingRules = normalized.branchingRules.map((br: any) => {
            return omit(br, 'id')
          })
        }
        return normalized
      })
    }

    const oldTemplateQuestionsWithoutID = normalizeTemplateQuestions(oldTemplate.templateQuestions)
    const newTemplateQuestionsWithoutID = normalizeTemplateQuestions(newTemplate.templateQuestions)
    
    // Compare templateQuestions (deep comparison after normalization)
    if (newTemplate.templateQuestions && !isEqual(oldTemplateQuestionsWithoutID, newTemplateQuestionsWithoutID)) {
      diff.templateQuestions = newTemplate.templateQuestions
    }
    
    // Compare localizations (deep comparison)
    const newLocalizations = newTemplate.localizations || []
    const oldLocalizations = oldTemplate.localizations || []
    if (newTemplate.localizations && !isEqual(newLocalizations, oldLocalizations)) {
      (diff as any).localizations = newLocalizations
    }
    
    return diff
  },

}
